<template>
    <Popup
        :modelValue=!!PopUpOpen
        @update:model-value=closeChild
        title="VCFS Payment Creation"
        hasClose
    >
        <template #contents>
            <div class="top-content">
                <div class="grid-item">
                    {{ "Requesting the calculation and creation of payments to VCFS of customer and dealer collections untill the cutoff date" }}
                </div>
                <form class="top-content" @submit.prevent=CreatePayment>
                    <div class="date-picker vcfs-date-selector">
                        <DatePicker
                        v-model=selectedDate
                        placeholder="Select cutoff date..."
                        :text-input-options=textInputOptions
                        :max-date="maxDay"
                        :enable-time-picker=false
                        :format=FormatDatePicker
                        :teleport=true
                        text-input
                        required
                        />
                    </div>
                    <div class="flex-col-centered">
                        <button class="submit-btn" type="submit">
                            CREATE PAYMENT
                        </button>
                    </div>
                </form>
            </div>
        </template>
    </Popup>
</template>
<script setup lang="ts">
import { ref, computed } from "vue";
import Popup from "./Popup.vue";
import DatePicker from "./common/DatePicker.vue";
import DateIgnoreTime from "@/types/DateIgnoreTime";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import { authService } from "@/auth/authSingleton";
import { vcfsPaymentsService } from "@/services/network";
import { IVcfsPaymentRequest } from "@/Interfaces/Payments/IVcfsPaymentRequest";

const props = defineProps<{
    modelValue?: boolean;
}>();
const emits = defineEmits<{
    (e: 'update:modelValue', val: boolean): void;
    (e: 'confirm'): void;
}>();
const PopUpOpen = computed<boolean>({
    get() {
        return props.modelValue ?? false; 
    },
    set(val: boolean) {
        emits('update:modelValue', val);
    }
});

const textInputOptions = { format: "yyyy-MM-dd" };
const maxDay = new Date().addDays(7);
const selectedDate = ref<Date>();
const working = ref(false);

function closeChild() {
    PopUpOpen.value = false;
}
function FormatDatePicker(date: Date){
    return new DateIgnoreTime(date).toString();
}
async function CreatePayment() {
    if(working.value == true) return;
    const closeSpinner = useSpinnerPopup().show();
    try{
        working.value = true
        const user = authService.getEmailAddress()
        const postRequest: IVcfsPaymentRequest = 
        {
            user: user, 
            date: new DateIgnoreTime(selectedDate.value)
        }
        const response = await vcfsPaymentsService.post(postRequest)
        if(response.status == 204){
            useNotifierWithErrFormatter().notify({msg: "There is no data within the selected cutoff date that can be consolidated into a payment item." });
        }

    }catch(error){
        useNotifierWithErrFormatter().error({errorType:"VCFS payment creation", error})
    }finally{
        closeSpinner();
        working.value = false
        closeChild()
        emits("confirm");
    }
}
</script>
<style scoped>
@import "@/assets/styles/selection-form-inputs.scss";
.grid-item {
    padding: 10px;
}
.submit-btn {
    margin-top: 1rem;
    cursor: pointer;
    border-width: 0px;
    border-radius: var(--buttons-border-radius);
    background-color: var(--primary-color-lighter);
    padding: 10px;
    color: blue;
    font-size: larger;
    font-weight: bold;
    &:hover {
        color: white;
        background-color: var(--primary-color);
    }
}
.vcfs-date-selector {
    width: 80%; 
    margin: auto;
    max-width: 600px;
}
</style>